import React from 'react';

const HoverLogoWhite = ({ ...props }) => (
  <svg
    width="137"
    height="36"
    viewBox="0 0 137 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M50.3916 19.1673H40.5985V11.0767H38.1914V29.8628H40.5985V21.6471H50.3916V29.8628H52.7987V11.0767H50.3916V19.1673Z"
      fill="white"
    />
    <path
      d="M68.0038 10.8206C62.7995 10.8206 59.0273 14.879 59.0273 20.4767C59.0273 26.0744 62.8056 30.1263 68.0038 30.1263C73.202 30.1263 76.9802 26.0678 76.9802 20.4767C76.9802 14.8856 73.208 10.8206 68.0038 10.8206ZM72.6291 25.6403C71.453 26.9098 69.8076 27.607 68.0038 27.607C66.2 27.607 64.5668 26.9098 63.3845 25.6403C62.184 24.3444 61.5259 22.5092 61.5259 20.4767C61.5259 18.4442 62.184 16.6024 63.3845 15.3132C64.5607 14.0437 66.2 13.3464 68.0038 13.3464C69.8076 13.3464 71.453 14.0437 72.6291 15.3132C73.8296 16.6024 74.4939 18.4376 74.4939 20.4767C74.4939 22.5158 73.8296 24.3444 72.6291 25.6403Z"
      fill="white"
    />
    <path
      d="M89.0217 26.9032L82.684 11.0771H80.1123L87.5896 29.712L87.6445 29.8632H90.3563L97.8763 11.0771H95.3716L89.0217 26.9032Z"
      fill="white"
    />
    <path
      d="M105.171 21.6345H114.123V19.181H105.171V13.5438H115.725V11.0771H102.77V29.8632H115.829V27.3966H105.171V21.6345Z"
      fill="white"
    />
    <path
      d="M130.753 21.8186C132.935 21.4569 135.165 19.9111 135.165 16.4841C135.165 14.7607 134.623 13.4123 133.551 12.4716C132.49 11.5442 130.967 11.0771 129.017 11.0771H122.143V29.8632H124.55V21.9041H128.066L133.307 29.8632H136.201L130.753 21.8186ZM124.55 19.5033V13.5438H128.992C131.442 13.5438 132.685 14.5305 132.685 16.4841C132.685 18.4903 131.442 19.5033 128.992 19.5033H124.55Z"
      fill="white"
    />
    <path
      d="M0 16.0037V30.8958L9.04347 26.0019V11.1033L0 16.0037Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3787 14.9776L29.3788 14.9776L15.8197 0L4.52148 6.1239L18.0805 21.1013L18.0804 21.1014V36L29.3787 29.8761V14.9776Z"
      fill="white"
    />
    <path
      d="M13.5596 34.7238L9.04395 33.4477V26.0017L13.5596 27.2712V34.7238Z"
      fill="white"
    />
    <path
      d="M0 16.0037V30.8958L9.04347 26.0019V11.1033L0 16.0037Z"
      fill="white"
    />
    <path
      d="M29.3788 14.9776L18.0806 21.1015L4.52148 6.1239L15.8197 0L29.3788 14.9776Z"
      fill="white"
    />
    <path
      d="M13.5596 34.7238L9.04395 33.4477V26.0017L13.5596 27.2712V34.7238Z"
      fill="white"
    />
  </svg>
);

export default HoverLogoWhite;
